import { forwardRef } from 'react';
import type { DropdownMenuItemProps } from '@radix-ui/react-dropdown-menu';
import { DropdownMenuItem } from '@radix-ui/react-dropdown-menu';
import type { MenuItemButtonProps } from './MenuItemButton';
import { MenuItemButton } from './MenuItemButton';

export type MenuItemProps = DropdownMenuItemProps &
  MenuItemButtonProps & {
    /**
     * Treats the menu item as a link when provided
     */
    href?: MenuItemButtonProps['href'];
  };

export const MenuItem = forwardRef<HTMLAnchorElement | HTMLButtonElement, MenuItemProps>(
  ({ onSelect = () => null, ...props }: MenuItemProps, ref) => {
    return (
      <DropdownMenuItem
        asChild={true}
        onSelect={onSelect}
      >
        <MenuItemButton
          {...props}
          ref={ref}
          leftIcon={props.icon}
        />
      </DropdownMenuItem>
    );
  },
);

MenuItem.displayName = 'MenuItem';
